import {
  ClaimWithContentSection,
  ResponsiveImage,
  responsiveImageComponentName,
  SectionWithImageGroups,
} from './types';

const isImage = (
  component: ClaimWithContentSection,
): component is ResponsiveImage =>
  component.strapi_component === responsiveImageComponentName;

export const groupImages = (sections: ClaimWithContentSection[]) => {
  let currentImageGroup: ResponsiveImage[] = [];
  const sectionsWithImageGroups: SectionWithImageGroups[] = [];

  sections.forEach((section) => {
    if (isImage(section)) {
      currentImageGroup.push(section);
    } else {
      // Add the current image group to sections before continuing with the non image sections
      if (currentImageGroup.length > 0) {
        sectionsWithImageGroups.push(currentImageGroup);
        currentImageGroup = [];
      }
      sectionsWithImageGroups.push(section);
    }
  });

  return [
    ...sectionsWithImageGroups,
    // append current image group only if it's not empty
    ...(currentImageGroup.length > 0 ? [currentImageGroup] : []),
  ];
};
